var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loggedIn)?_c('h3',[_vm._v("Welcome, "+_vm._s(_vm.currentUser.first_name))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }